export default {
    //serverUrl: "https://localhost:5001/",
    serverUrl: window.location.origin + "/",
    //serverUrl: "http://localhost:51778/",
    //serverUrl: "https://seslim.arksoft.local/",
};
